import React from 'react';
import { Snackbar, Alert, AlertColor, Portal } from '@mui/material';
import { Z_INDEX } from '../../constants/zIndex';

interface NotificationProps {
  open: boolean;
  message: string;
  severity: AlertColor;
  onClose: () => void;
  autoHideDuration?: number;
}

export const Notification: React.FC<NotificationProps> = ({
  open,
  message,
  severity,
  onClose,
  autoHideDuration = 6000
}) => {
  // Use Portal to render at document body level, escaping any modal stacking context
  return (
    <Portal>
      <Snackbar
        open={open}
        autoHideDuration={autoHideDuration}
        onClose={onClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        sx={{ 
          zIndex: `${Z_INDEX.NOTIFICATION} !important`,
          position: 'fixed',
          top: 72,
          left: '50%',
          transform: 'translateX(-50%)',
          '& .MuiSnackbar-root': {
            zIndex: `${Z_INDEX.NOTIFICATION} !important`
          }
        }}
      >
        <Alert 
          onClose={onClose} 
          severity={severity}
          sx={{ 
            width: '100%',
            minWidth: 300,
            boxShadow: '0 8px 32px rgba(0,0,0,0.35)',
            zIndex: Z_INDEX.NOTIFICATION,
            border: '1px solid',
            borderColor: severity === 'error' ? 'error.main' : 
                        severity === 'warning' ? 'warning.main' : 
                        severity === 'success' ? 'success.main' : 'info.main'
          }}
        >
          {message}
        </Alert>
      </Snackbar>
    </Portal>
  );
}; 